module.exports = __webpack_public_path__ + "static/blueprint-logo-f7aa047246594901a9e1daa55d7dbbf4.png";